import React from "react";
import { Box, Grid } from "@material-ui/core";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import LinearProgress from "@mui/material/LinearProgress";
import { MetaTags } from "react-meta-tags";
import axios from "axios";
import ClassTestDashboard from "../components/ClassTestDashboard";
import DashboardBlank from "../components/DashboardBlank";
import { API_URL } from "../utils/EnvVars";
import { makeStyles } from "@material-ui/core/styles";
import Header from "./HeaderMy";
import Cookies from "js-cookie";
import LeftDrawer from "../components/LeftDrawer";
import NotificationAlerts from "../components/NotificationAlerts";

// CSS
import "font-awesome/css/font-awesome.min.css";
import "../styles/bizofficer-a.css";

const useStyles = makeStyles((theme) => ({
  content: {
    [theme.breakpoints.up("md")]: {
      marginLeft: 240,
      marginTop: 60,
    },
    padding: theme.spacing(1),
  },
}));

export default function Execute() {
  const classes = useStyles();
  var etlStudentObj = JSON.parse(localStorage.getItem("etlStudentObj"));
  
  var selectedCourse = localStorage.getItem("etlSelectCourse");
  var mySelectedCourses = JSON.parse(localStorage.getItem("etlMyCourses"));
  const authResult = new URLSearchParams(window.location.search);
  const deviceType = authResult.get("device_type");
  if (deviceType && deviceType.length > 0) {
    localStorage.setItem("deviceType", deviceType);
  }
  const [pageLoader, setPageLoader] = React.useState(true);
  const [blankDashboard, setBlankDashboard] = React.useState(false);
  const [selfTestData, setSelfTestData] = React.useState([]);
  const [topicTestData, setTopicTestData] = React.useState([]);
  const [mockTestData, setMockTestData] = React.useState([]);
  const [classTestData, setClassTestData] = React.useState([]);
  const [clasTestList, setClasTestList] = React.useState([]);

  const [chartSelfAssessorOneData, setChartSelfAssessorOneData] =
    React.useState({
      credits: false,
      chart: { type: "pie" },
      title: { text: "Last Report" },
      subtitle: { text: "ATOMIC STRUCTURE" },
      caption: { text: "" },
      tooltip: { valueSuffix: "%" },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            distance: -30,
            style: { fontSize: "12px", textOutline: 0 },
            enabled: true,
            format: "{point.y} %",
          },
        },
      },
      series: [{ showInLegend: true, name: "", data: [] }],
    });
  const [chartSelfAssessorTwoData, setChartSelfAssessorTwoData] =
    React.useState({
      credits: false,
      chart: { type: "column" },
      title: { text: "Last 5 Performance" },
      caption: { text: "" },
      tooltip: { valueSuffix: " %" },
      xAxis: { categories: [] },
      yAxis: { title: { text: "" } },
      plotOptions: {
        column: {
          threshold: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return this.y < 0 ? -this.y + " %" : this.y + " %";
            },
          },
        },
      },
      series: [
        {
          cursor: "pointer",
          point: {
            events: {
              click: function () {
                window.location.href = this.options.testDetails;
              },
            },
          },
          showInLegend: false,
          name: "Marks",
          title: null,
          data: [],
        },
      ],
    });
  const [chartSelfAssessorThreeData, setChartSelfAssessorThreeData] =
    React.useState({
      credits: false,
      chart: { type: "pie" },
      title: { text: "Accuracy of Attempted Questions" },
      subtitle: { text: "" },
      caption: { text: "" },
      tooltip: { valueSuffix: " %" },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            distance: -30,
            style: { fontSize: "12px", textOutline: 0 },
            enabled: true,
            format: "{point.y} %",
          },
        },
      },
      series: [{ showInLegend: true, name: "", data: [] }],
    });

  const [chartTopicTestOneData, setChartTopicTestOneData] = React.useState({
    credits: false,
    chart: { type: "pie" },
    title: { text: "Last Report" },
    subtitle: { text: "ATOMIC STRUCTURE" },
    caption: { text: "" },
    tooltip: { valueSuffix: " %" },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          distance: -30,
          style: { fontSize: "12px", textOutline: 0 },
          enabled: true,
          format: "{point.y} %",
        },
      },
    },
    series: [{ showInLegend: true, name: "", data: [] }],
  });
  const [chartTopicTestTwoData, setChartTopicTestTwoData] = React.useState({
    credits: false,
    chart: { type: "column" },
    title: { text: "Last 5 Performance" },
    caption: { text: "" },
    tooltip: { valueSuffix: " %" },
    xAxis: { categories: [] },
    yAxis: { title: { text: "" } },
    plotOptions: {
      column: {
        threshold: 0,
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y < 0 ? -this.y + " %" : this.y + " %";
          },
        },
      },
    },
    series: [
      {
        cursor: "pointer",
        point: {
          events: {
            click: function () {
              window.location.href = this.options.testDetails;
            },
          },
        },
        showInLegend: false,
        name: "Marks",
        title: null,
        data: [],
      },
    ],
  });
  ///	const [chartTopicTestTwoData, setChartTopicTestTwoData] = React.useState({credits: false,chart: {type: 'column'},title: {text: 'Last 5 Performance'},caption: {text: ''},tooltip: {valueSuffix: ' %'},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + ' %' : this.y + ' %'}}}},series: [{showInLegend: false,name: 'Marks',title:null, data: []}]});
  const [chartTopicTestThreeData, setChartTopicTestThreeData] = React.useState({
    credits: false,
    chart: { type: "pie" },
    title: { text: "Accuracy of Attempted Questions" },
    subtitle: { text: "" },
    caption: { text: "" },
    tooltip: { valueSuffix: " %" },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          distance: -30,
          style: { fontSize: "12px", textOutline: 0 },
          enabled: true,
          format: "{point.y} %",
        },
      },
    },
    series: [{ showInLegend: true, name: "", data: [] }],
  });

  const [chartMockTestOneData, setChartMockTestOneData] = React.useState({
    credits: false,
    chart: { type: "pie" },
    title: { text: "Last Report" },
    subtitle: { text: "ATOMIC STRUCTURE" },
    caption: { text: "" },
    tooltip: { valueSuffix: " " },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          distance: -30,
          style: { fontSize: "12px", textOutline: 0 },
          enabled: true,
          format: "{point.y} %",
        },
      },
    },
    series: [{ showInLegend: true, name: "", data: [] }],
  });
  const [chartMockTestTwoData, setChartMockTestTwoData] = React.useState({
    credits: false,
    chart: { type: "column" },
    title: { text: "Last 5 Performance" },
    caption: { text: "" },
    tooltip: { valueSuffix: " %" },
    xAxis: { categories: [] },
    yAxis: { title: { text: "" } },
    plotOptions: {
      column: {
        threshold: 0,
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y < 0 ? -this.y + " %" : this.y + " %";
          },
        },
      },
    },
    series: [
      {
        cursor: "pointer",
        point: {
          events: {
            click: function () {
              window.location.href = this.options.testDetails;
            },
          },
        },
        showInLegend: false,
        name: "Marks",
        title: null,
        data: [],
      },
    ],
  });
  ///const [chartMockTestTwoData, setChartMockTestTwoData] = React.useState({credits: false,chart: {type: 'column'},title: {text: 'Last 5 Performance'},caption: {text: ''},tooltip: {valueSuffix: ' %'},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + ' %' : this.y + ' %'}}}},series: [{showInLegend: false,name: 'Marks',title:null, data: []}]});
  const [chartMockTestThreeData, setChartMockTestThreeData] = React.useState({
    credits: false,
    chart: { type: "pie" },
    title: { text: "Accuracy of Attempted Questions" },
    subtitle: { text: "" },
    caption: { text: "" },
    tooltip: { valueSuffix: "%" },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          distance: -30,
          style: { fontSize: "12px", textOutline: 0 },
          enabled: true,
          format: "{point.y} %",
        },
      },
    },
    series: [{ showInLegend: true, name: "", data: [] }],
  });

  const [chartClassTestOneData, setChartClassTestOneData] = React.useState({
    credits: false,
    chart: { type: "pie" },
    title: { text: "Last Report" },
    subtitle: { text: "ATOMIC STRUCTURE" },
    caption: { text: "" },
    tooltip: { valueSuffix: " " },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          distance: -30,
          style: { fontSize: "12px", textOutline: 0 },
          enabled: true,
          format: "{point.y} %",
        },
      },
    },
    series: [{ showInLegend: true, name: "", data: [] }],
  });
  const [chartClassTestTwoData, setChartClassTestTwoData] = React.useState({
    credits: false,
    chart: { type: "column" },
    title: { text: "Last 5 Performance" },
    caption: { text: "" },
    tooltip: { valueSuffix: " %" },
    xAxis: { categories: [] },
    yAxis: { title: { text: "" } },
    plotOptions: {
      column: {
        threshold: 0,
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y < 0 ? -this.y + " %" : this.y + " %";
          },
        },
      },
    },
    series: [
      {
        cursor: "pointer",
        point: {
          events: {
            click: function () {
              window.location.href = this.options.testDetails;
            },
          },
        },
        showInLegend: false,
        name: "Marks",
        title: null,
        data: [],
      },
    ],
  });
  ///	const [chartClassTestTwoData, setChartClassTestTwoData] = React.useState({credits: false,chart: {type: 'column'},title: {text: 'Last 5 Performance'},caption: {text: ''},tooltip: {valueSuffix: ' %'},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + ' %' : this.y + ' %'}}}},series: [{showInLegend: false,name: 'Marks',title:null, data: []}]});
  const [chartClassTestThreeData, setChartClassTestThreeData] = React.useState({
    credits: false,
    chart: { type: "pie" },
    title: { text: "Accuracy of Attempted Questions" },
    subtitle: { text: "" },
    caption: { text: "" },
    tooltip: { valueSuffix: "%" },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          distance: -30,
          style: { fontSize: "12px", textOutline: 0 },
          enabled: true,
          format: "{point.y} %",
        },
      },
    },
    series: [{ showInLegend: true, name: "", data: [] }],
  });
  const [smartLearningNav, setSmartLearningNav] = React.useState(0);
  const [mockTestNav, setMockTestNav] = React.useState(0);
  // check if logged in
  if (localStorage.getItem("etlStudentObj") === null) {
    window.location.href = "login";
  }

  React.useEffect(() => {
    getApiData();
    if (
      mySelectedCourses &&
      selectedCourse &&
      mySelectedCourses[selectedCourse] &&
      mySelectedCourses[selectedCourse].courseId > 0
    ) {
      getApiDataClassTest(mySelectedCourses[selectedCourse].courseId);
    }
  }, []);

  async function getApiData() {
    if (
      mySelectedCourses[selectedCourse].courseId &&
      etlStudentObj.loginId &&
      etlStudentObj.token
    ) {
      try {
        let axiosHeader = {
          headers: {
            "Content-Type": "multipart/mixed",
            loginId: etlStudentObj.loginId,
            token: etlStudentObj.token,
            device: "web",
          },
        };
        axios
          .get(
            API_URL +
              "/dashboard?courseId=" +
              mySelectedCourses[selectedCourse].courseId,
            axiosHeader
          ) ///dashboard?organisationId=71&studentId=iit_demot
          .then((response) => {
            setPageLoader(false);
            ///console.log("Data: "+response.data.obj);
            if (
              response &&
              response.data &&
              response.data.responseTxt === "success" &&
              response.data.obj &&
              response.data.obj.length > 0
            ) {
              setBlankDashboard(false);
              if (
                response.data.obj[0] &&
                response.data.obj[0] !== null &&
                response.data.obj[0].testType !== null &&
                response.data.obj[0].testLastReport !== null
              ) {
                ///console.log("B testType => "+response.data[0].testType);
                setSelfTestData(response.data.obj[0]);
                setChartSelfAssessorOneData({
                  series: [{ data: response.data.obj[0].testLastReport }],
                });
                setChartSelfAssessorOneData({
                  subtitle: { text: response.data.obj[0].testLastTopic },
                });
                setChartSelfAssessorTwoData({
                  xAxis: [{ categories: response.data.obj[0].testLastTestsX }],
                });
                setChartSelfAssessorTwoData({
                  series: [{ data: response.data.obj[0].testLastTestsY }],
                });
                setChartSelfAssessorTwoData({
                  title: { text: response.data.obj[0].lastPerformance },
                });
                setChartSelfAssessorThreeData({
                  series: [{ data: response.data.obj[0].testAccuracy }],
                });
                setChartSelfAssessorThreeData({
                  subtitle: { text: response.data.obj[0].testLastTopic },
                });
              }

              if (
                response.data.obj[1] &&
                response.data.obj[1] !== null &&
                response.data.obj[1].testType !== null &&
                response.data.obj[1].testLastReport !== null
              ) {
                ///console.log("D testType => "+response.data.obj[1].testType);
                setTopicTestData(response.data.obj[1]);
                setChartTopicTestOneData({
                  series: [{ data: response.data.obj[1].testLastReport }],
                });
                setChartTopicTestOneData({
                  subtitle: { text: response.data.obj[1].testLastTopic },
                });
                setChartTopicTestTwoData({
                  xAxis: [{ categories: response.data.obj[1].testLastTestsX }],
                });
                setChartTopicTestTwoData({
                  series: [{ data: response.data.obj[1].testLastTestsY }],
                });
                setChartTopicTestTwoData({
                  title: { text: response.data.obj[1].lastPerformance },
                });
                setChartTopicTestThreeData({
                  series: [{ data: response.data.obj[1].testAccuracy }],
                });
                setChartTopicTestThreeData({
                  subtitle: { text: response.data.obj[1].testLastTopic },
                });
              }

              if (
                response.data.obj[2] &&
                response.data.obj[2] !== null &&
                response.data.obj[2].testType !== null &&
                response.data.obj[2].testLastReport !== null
              ) {
                ///console.log("F testType => "+response.data.obj[2].testType);
                setMockTestData(response.data.obj[2]);
                setChartMockTestOneData({
                  series: [{ data: response.data.obj[2].testLastReport }],
                });
                setChartMockTestOneData({
                  subtitle: { text: response.data.obj[2].testLastTopic },
                });
                setChartMockTestTwoData({
                  xAxis: [{ categories: response.data.obj[2].testLastTestsX }],
                });
                setChartMockTestTwoData({
                  series: [{ data: response.data.obj[2].testLastTestsY }],
                });
                setChartMockTestTwoData({
                  title: { text: response.data.obj[2].lastPerformance },
                });
                setChartMockTestThreeData({
                  series: [{ data: response.data.obj[2].testAccuracy }],
                });
                setChartMockTestThreeData({
                  subtitle: { text: response.data.obj[2].testLastTopic },
                });
              }

              if (
                response.data.obj[3] &&
                response.data.obj[3] !== null &&
                response.data.obj[3].testType !== null &&
                response.data.obj[3].testLastReport !== null
              ) {
                ///console.log("H testType => "+response.data.obj[3].testType);
                setClassTestData(response.data.obj[3]);
                setChartClassTestOneData({
                  series: [{ data: response.data.obj[3].testLastReport }],
                });
                setChartClassTestOneData({
                  subtitle: { text: response.data.obj[3].testLastTopic },
                });
                setChartClassTestTwoData({
                  xAxis: [{ categories: response.data.obj[3].testLastTestsX }],
                });
                setChartClassTestTwoData({
                  series: [{ data: response.data.obj[3].testLastTestsY }],
                });
                setChartClassTestTwoData({
                  title: { text: response.data.obj[3].lastPerformance },
                });
                setChartClassTestThreeData({
                  series: [{ data: response.data.obj[3].testAccuracy }],
                });
                setChartClassTestThreeData({
                  subtitle: { text: response.data.obj[3].testLastTopic },
                });
              }
            } else if (
              response &&
              response.data &&
              response.data.responseTxt === "invalidToken"
            ) {
              window.localStorage.removeItem("etlStudentObj");
              window.localStorage.clear();
              window.location.href = "logout";
            } else {
              setBlankDashboard(true);
              ///setMessage("No data available");
            }
          });
      } catch (error) {
        const { response } = error;
        const { request, ...errorObject } = response; // take everything but 'request'
        console.log(errorObject);
      }
    }
  }

  async function getApiDataClassTest(courseId) {
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: etlStudentObj.loginId,
        token: etlStudentObj.token,
        device: "web",
      },
    };
    axios
      .get(
        API_URL + "/classtestlist?source=dashboard&courseId=" + courseId,
        axiosHeader
      )
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.responseTxt === "success"
        ) {
          if (response.data.obj && response.data.obj.length > 0) {
            setClasTestList(response.data.obj);
          }
        } else if (
          response &&
          response.data &&
          response.data.responseTxt === "invalidToken"
        ) {
          window.localStorage.removeItem("etlStudentObj");
          window.localStorage.clear();
          window.location.href = "logout";
        }
      });
  }

  React.useEffect(() => {
    if (
      mySelectedCourses &&
      mySelectedCourses[selectedCourse] &&
      mySelectedCourses[selectedCourse].selfTest === 1
    ) {
      setSmartLearningNav(1);
    }
    if (
      mySelectedCourses &&
      mySelectedCourses[selectedCourse] &&
      mySelectedCourses[selectedCourse].mockTest === 1
    ) {
      setMockTestNav(1);
    }
  });

  return (
    <div>
      <MetaTags>
        <title>Dashboard</title>
      </MetaTags>
      <Header />
      {/* menuOpen={blankDashboard?true:false} */}
      <LeftDrawer />
      <main className={classes.content}>
        <NotificationAlerts />
        {/* <Toolbar /> */}
        {pageLoader ? <LinearProgress /> : null}
        <Box style={{ marginBottom: 100, marginLeft: 20, marginRight: 20 }}>
          {!blankDashboard ? (
            <Box mt={1}>
              <Grid container spacing={2}>
                <Grid item md={12} xs={12}>
                  <h3 className="heading">Dashboard</h3>
                </Grid>
              </Grid>
            </Box>
          ) : null}

          <ClassTestDashboard clasTestList={clasTestList} />

          {blankDashboard ? (
            <Box mt={1}>
              {/* <Grid container spacing={2}>
                <Grid item md={12} xs={12} style={{ textAlign: "center" }}>
                  <a href="selfassessor">
                    <img
                      src={process.env.PUBLIC_URL + "/begin-learning.jpg"}
                      style={{maxWidth: "100%"}}
                      alt="Begin Learning"
                    />
                  </a>

                </Grid>
              </Grid> */}

              <DashboardBlank />
            </Box>
          ) : null}

          {selfTestData &&
          selfTestData != null &&
          selfTestData.testType != null ? (
            <>
              <Box mt={1}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <h3 className="heading" style={{ textAlign: "center" }}>
                      {selfTestData.testType}
                    </h3>
                  </Grid>
                </Grid>
              </Box>
              <Box mt={1}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartSelfAssessorTwoData}
                    />
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartSelfAssessorOneData}
                    />
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartSelfAssessorThreeData}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          ) : null}

          {topicTestData &&
          topicTestData != null &&
          topicTestData.testType != null ? (
            <>
              <Box mt={10}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <h3 className="heading" style={{ textAlign: "center" }}>
                      {topicTestData.testType}
                    </h3>
                  </Grid>
                </Grid>
              </Box>
              <Box mt={1}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartTopicTestTwoData}
                    />
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartTopicTestOneData}
                    />
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartTopicTestThreeData}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          ) : null}

          {mockTestData &&
          mockTestData != null &&
          mockTestData.testType != null ? (
            <>
              <Box mt={10}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <h3 className="heading" style={{ textAlign: "center" }}>
                      {mockTestData.testType}
                    </h3>
                  </Grid>
                </Grid>
              </Box>
              <Box mt={1}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartMockTestTwoData}
                    />
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartMockTestOneData}
                    />
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartMockTestThreeData}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          ) : null}

          {classTestData &&
          classTestData != null &&
          classTestData.testType != null ? (
            <>
              <Box mt={10}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <h3 className="heading" style={{ textAlign: "center" }}>
                      {classTestData.testType}
                    </h3>
                  </Grid>
                </Grid>
              </Box>
              <Box mt={1}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartClassTestTwoData}
                    />
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartClassTestOneData}
                    />
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    style={{ backgroundColor: "#F7F7F7" }}
                  >
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={chartClassTestThreeData}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          ) : null}
        </Box>
      </main>
    </div>
  );
}
